'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _notification = require('bender-url!../../audio/notification.mp3');

Object.defineProperty(exports, 'notification', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_notification).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-internal-components/static-1.4266/js/assets/audio.js
// module id = 835
// module chunks = 2 3